// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wizzy — KI-Chat landing page */

.agent-chat-layout {
  height: 100vh;
}

/* Sidebar ------------------------------------------------------------- */

.agent-chat-sider {
  border-right: 1px solid var(--wz-line);
  overflow-y: auto;
  box-shadow: 1px 0 0 rgba(18, 22, 15, 0.02);
}

.agent-sider-content {
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 100%;
}

/* Administration at the foot of the sidebar, set off from the lists above */
.agent-sider-admin {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid var(--wz-line);
}

.agent-sider-admin .ant-btn {
  height: 36px;
  font-weight: 500;
}

.agent-sider-note {
  margin-top: 8px;
  font-size: 11.5px;
  line-height: 1.4;
  color: var(--wz-text-3);
}

.agent-sider-content > .ant-btn {
  height: 40px;
  font-weight: 600;
}

.agent-sider-heading {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--wz-text-2);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.agent-sider-heading .anticon {
  color: var(--wz-green-deep);
  font-size: 12px;
}

.agent-sider-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
  max-height: 38vh;
  overflow-y: auto;
}

.agent-chat-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border-radius: var(--wz-r-sm);
  cursor: pointer;
  font-size: 13px;
  color: var(--wz-text);
  border: 1px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.agent-chat-item:hover {
  background: var(--wz-green-tint);
}

.agent-chat-item-active {
  background: var(--wz-green-tint-2);
  border-color: rgba(164, 189, 45, 0.35);
  font-weight: 600;
}

.agent-chat-item-title {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-chat-item-actions {
  display: none;
  gap: 8px;
  color: var(--wz-text-3);
  flex-shrink: 0;
}

.agent-chat-item:hover .agent-chat-item-actions {
  display: inline-flex;
}

.agent-chat-item-actions .anticon:hover {
  color: var(--wz-green-deep);
}

.agent-estimation-date {
  font-size: 11px;
  color: var(--wz-text-3);
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

/* Header --------------------------------------------------------------- */

.agent-chat-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--wz-card);
  padding: 0 28px;
  border-bottom: 1px solid var(--wz-line);
}

.agent-chat-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg,
    var(--wz-green) 0%,
    var(--wz-green-strong) 38%,
    rgba(182, 206, 59, 0.12) 100%);
  pointer-events: none;
}

.agent-chat-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.agent-chat-logo {
  height: 36px;
  vertical-align: middle;
}

.agent-chat-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.agent-chat-user {
  color: var(--wz-text-2);
  font-size: 13px;
  font-weight: 500;
  padding: 5px 14px;
  border: 1px solid var(--wz-line);
  border-radius: 999px;
  background: var(--wz-bg);
  line-height: 1.4;
}

/* Conversation area ----------------------------------------------------- */

.agent-chat-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  background: var(--wz-bg);
}

.agent-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 28px 0 8px;
}

.agent-chat-message-list,
.agent-chat-empty {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 24px;
}

.agent-chat-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  gap: 10px;
}

/* Monogram badge above the greeting */
.agent-chat-empty::before {
  content: 'W';
  font-family: var(--wz-font-display);
  font-weight: 700;
  font-size: 26px;
  color: var(--wz-green);
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: linear-gradient(150deg, var(--wz-ink-2) 0%, var(--wz-ink) 100%);
  box-shadow: var(--wz-shadow-md), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  margin-bottom: 8px;
}

.agent-chat-empty h3 {
  font-size: 30px;
  margin-bottom: 0;
}

.agent-suggestions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 26px;
  max-width: 680px;
}

.agent-suggestion-chip {
  cursor: pointer;
  padding: 8px 16px;
  font-size: 13px;
  border-radius: 999px;
  background: var(--wz-card);
  border: 1px solid var(--wz-line-2);
  color: var(--wz-text-2);
  margin: 0;
  transition: all 0.18s ease;
  box-shadow: var(--wz-shadow-sm);
}

.agent-suggestion-chip:hover {
  border-color: var(--wz-green-strong);
  color: var(--wz-ink);
  transform: translateY(-1px);
  box-shadow: var(--wz-shadow-md);
  background: var(--wz-card);
}

.agent-message {
  margin-bottom: 18px;
}

.agent-message-user {
  display: flex;
  justify-content: flex-end;
}

.agent-message-bubble {
  background: linear-gradient(150deg, var(--wz-ink-2) 0%, var(--wz-ink) 100%);
  color: #f4f6ec;
  border-radius: 16px 16px 4px 16px;
  padding: 11px 18px;
  max-width: 75%;
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 1.55;
  box-shadow: var(--wz-shadow-sm);
}

.agent-message-assistant {
  background: var(--wz-card);
  border: 1px solid var(--wz-line);
  border-radius: 16px;
  padding: 16px 20px;
  box-shadow: var(--wz-shadow-sm);
  font-size: 14px;
  line-height: 1.6;
}

.agent-thinking {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--wz-text-3);
}

.agent-tool-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--wz-text-2);
  background: var(--wz-bg);
  border: 1px solid var(--wz-line);
  border-radius: 999px;
  padding: 4px 14px;
  margin: 4px 8px 4px 0;
}

.agent-markdown p:last-child {
  margin-bottom: 0;
}

.agent-markdown table {
  border-collapse: collapse;
  margin: 10px 0;
  font-variant-numeric: tabular-nums;
}

.agent-markdown th,
.agent-markdown td {
  border: 1px solid var(--wz-line);
  padding: 5px 12px;
  font-size: 13px;
}

.agent-markdown th {
  background: #f4f6ec;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--wz-text-2);
}

.agent-table-block,
.agent-chart-block {
  margin: 12px 0;
}

.agent-projects-block {
  margin: 12px 0;
  border: 1px solid var(--wz-green-tint-2);
  border-left: 3px solid var(--wz-green);
  border-radius: var(--wz-r-md);
  padding: 14px 18px;
  background:
    linear-gradient(180deg, rgba(182, 206, 59, 0.06) 0%, rgba(182, 206, 59, 0.015) 100%),
    var(--wz-card);
}

.agent-projects-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

/* Input bar ------------------------------------------------------------- */

.agent-chat-input-bar {
  background: linear-gradient(180deg, rgba(246, 247, 241, 0) 0%, var(--wz-bg) 40%);
  padding: 10px 24px 30px;
}

.agent-chat-input-inner {
  width: 60%;
  min-width: 360px;
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  gap: 10px;
  align-items: flex-end;
  background: var(--wz-card);
  border: 1px solid var(--wz-line-2);
  border-radius: 22px;
  padding: 10px 10px 10px 20px;
  box-shadow: var(--wz-shadow-md);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.agent-chat-input-inner:focus-within {
  border-color: var(--wz-green-strong);
  box-shadow: 0 0 0 3px var(--wz-green-glow), var(--wz-shadow-md);
}

.agent-chat-input-inner .ant-input {
  padding-left: 0;
  font-size: 14.5px;
}

.agent-chat-input-inner .ant-btn {
  flex-shrink: 0;
  margin-bottom: 2px;
  width: 38px;
  height: 38px;
  min-width: 38px;
}

/* Three blinking dots: shown while a turn is still running and blocks have
   already been rendered, so the user can tell the agent is still working
   during the quiet stretches between tool calls. */
.agent-typing-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 0;
}

.agent-typing-dots i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--wz-text-3);
  opacity: 0.25;
  animation: agent-typing-blink 1.4s infinite ease-in-out both;
}

.agent-typing-dots i:nth-child(2) { animation-delay: 0.2s; }
.agent-typing-dots i:nth-child(3) { animation-delay: 0.4s; }

@keyframes agent-typing-blink {
  0%, 80%, 100% { opacity: 0.25; }
  40%           { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .agent-typing-dots i { animation: none; opacity: 0.6; }
}
`, "",{"version":3,"sources":["webpack://./src/components/AgentChat/AgentChat.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;AACf;;AAEA,0EAA0E;;AAE1E;EACE,sCAAsC;EACtC,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,0DAA0D;AAC5D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA,2EAA2E;;AAE3E;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;kCAGgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,4EAA4E;;AAE5E;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2EAA2E;EAC3E,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2EAA2E;EAC3E,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,sCAAsC;EACtC,6BAA6B;EAC7B,kBAAkB;EAClB;;kBAEgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA,4EAA4E;;AAE5E;EACE,gFAAgF;EAChF,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;EACpC,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;mDAEmD;AACnD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,4DAA4D;AAC9D;;AAEA,oCAAoC,qBAAqB,EAAE;AAC3D,oCAAoC,qBAAqB,EAAE;;AAE3D;EACE,gBAAgB,aAAa,EAAE;EAC/B,gBAAgB,UAAU,EAAE;AAC9B;;AAEA;EACE,uBAAuB,eAAe,EAAE,YAAY,EAAE;AACxD","sourcesContent":["/* Wizzy — KI-Chat landing page */\n\n.agent-chat-layout {\n  height: 100vh;\n}\n\n/* Sidebar ------------------------------------------------------------- */\n\n.agent-chat-sider {\n  border-right: 1px solid var(--wz-line);\n  overflow-y: auto;\n  box-shadow: 1px 0 0 rgba(18, 22, 15, 0.02);\n}\n\n.agent-sider-content {\n  padding: 18px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-height: 100%;\n}\n\n/* Administration at the foot of the sidebar, set off from the lists above */\n.agent-sider-admin {\n  margin-top: auto;\n  padding-top: 16px;\n  border-top: 1px solid var(--wz-line);\n}\n\n.agent-sider-admin .ant-btn {\n  height: 36px;\n  font-weight: 500;\n}\n\n.agent-sider-note {\n  margin-top: 8px;\n  font-size: 11.5px;\n  line-height: 1.4;\n  color: var(--wz-text-3);\n}\n\n.agent-sider-content > .ant-btn {\n  height: 40px;\n  font-weight: 600;\n}\n\n.agent-sider-heading {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.09em;\n  color: var(--wz-text-2);\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.agent-sider-heading .anticon {\n  color: var(--wz-green-deep);\n  font-size: 12px;\n}\n\n.agent-sider-list {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  max-height: 38vh;\n  overflow-y: auto;\n}\n\n.agent-chat-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: var(--wz-r-sm);\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--wz-text);\n  border: 1px solid transparent;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.agent-chat-item:hover {\n  background: var(--wz-green-tint);\n}\n\n.agent-chat-item-active {\n  background: var(--wz-green-tint-2);\n  border-color: rgba(164, 189, 45, 0.35);\n  font-weight: 600;\n}\n\n.agent-chat-item-title {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-chat-item-actions {\n  display: none;\n  gap: 8px;\n  color: var(--wz-text-3);\n  flex-shrink: 0;\n}\n\n.agent-chat-item:hover .agent-chat-item-actions {\n  display: inline-flex;\n}\n\n.agent-chat-item-actions .anticon:hover {\n  color: var(--wz-green-deep);\n}\n\n.agent-estimation-date {\n  font-size: 11px;\n  color: var(--wz-text-3);\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Header --------------------------------------------------------------- */\n\n.agent-chat-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--wz-card);\n  padding: 0 28px;\n  border-bottom: 1px solid var(--wz-line);\n}\n\n.agent-chat-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg,\n    var(--wz-green) 0%,\n    var(--wz-green-strong) 38%,\n    rgba(182, 206, 59, 0.12) 100%);\n  pointer-events: none;\n}\n\n.agent-chat-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.agent-chat-logo {\n  height: 36px;\n  vertical-align: middle;\n}\n\n.agent-chat-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.agent-chat-user {\n  color: var(--wz-text-2);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 5px 14px;\n  border: 1px solid var(--wz-line);\n  border-radius: 999px;\n  background: var(--wz-bg);\n  line-height: 1.4;\n}\n\n/* Conversation area ----------------------------------------------------- */\n\n.agent-chat-content {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 64px);\n  background: var(--wz-bg);\n}\n\n.agent-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 28px 0 8px;\n}\n\n.agent-chat-message-list,\n.agent-chat-empty {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.agent-chat-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  height: 100%;\n  gap: 10px;\n}\n\n/* Monogram badge above the greeting */\n.agent-chat-empty::before {\n  content: 'W';\n  font-family: var(--wz-font-display);\n  font-weight: 700;\n  font-size: 26px;\n  color: var(--wz-green);\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background: linear-gradient(150deg, var(--wz-ink-2) 0%, var(--wz-ink) 100%);\n  box-shadow: var(--wz-shadow-md), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  margin-bottom: 8px;\n}\n\n.agent-chat-empty h3 {\n  font-size: 30px;\n  margin-bottom: 0;\n}\n\n.agent-suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 26px;\n  max-width: 680px;\n}\n\n.agent-suggestion-chip {\n  cursor: pointer;\n  padding: 8px 16px;\n  font-size: 13px;\n  border-radius: 999px;\n  background: var(--wz-card);\n  border: 1px solid var(--wz-line-2);\n  color: var(--wz-text-2);\n  margin: 0;\n  transition: all 0.18s ease;\n  box-shadow: var(--wz-shadow-sm);\n}\n\n.agent-suggestion-chip:hover {\n  border-color: var(--wz-green-strong);\n  color: var(--wz-ink);\n  transform: translateY(-1px);\n  box-shadow: var(--wz-shadow-md);\n  background: var(--wz-card);\n}\n\n.agent-message {\n  margin-bottom: 18px;\n}\n\n.agent-message-user {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.agent-message-bubble {\n  background: linear-gradient(150deg, var(--wz-ink-2) 0%, var(--wz-ink) 100%);\n  color: #f4f6ec;\n  border-radius: 16px 16px 4px 16px;\n  padding: 11px 18px;\n  max-width: 75%;\n  white-space: pre-wrap;\n  font-size: 14px;\n  line-height: 1.55;\n  box-shadow: var(--wz-shadow-sm);\n}\n\n.agent-message-assistant {\n  background: var(--wz-card);\n  border: 1px solid var(--wz-line);\n  border-radius: 16px;\n  padding: 16px 20px;\n  box-shadow: var(--wz-shadow-sm);\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.agent-thinking {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--wz-text-3);\n}\n\n.agent-tool-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--wz-text-2);\n  background: var(--wz-bg);\n  border: 1px solid var(--wz-line);\n  border-radius: 999px;\n  padding: 4px 14px;\n  margin: 4px 8px 4px 0;\n}\n\n.agent-markdown p:last-child {\n  margin-bottom: 0;\n}\n\n.agent-markdown table {\n  border-collapse: collapse;\n  margin: 10px 0;\n  font-variant-numeric: tabular-nums;\n}\n\n.agent-markdown th,\n.agent-markdown td {\n  border: 1px solid var(--wz-line);\n  padding: 5px 12px;\n  font-size: 13px;\n}\n\n.agent-markdown th {\n  background: #f4f6ec;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--wz-text-2);\n}\n\n.agent-table-block,\n.agent-chart-block {\n  margin: 12px 0;\n}\n\n.agent-projects-block {\n  margin: 12px 0;\n  border: 1px solid var(--wz-green-tint-2);\n  border-left: 3px solid var(--wz-green);\n  border-radius: var(--wz-r-md);\n  padding: 14px 18px;\n  background:\n    linear-gradient(180deg, rgba(182, 206, 59, 0.06) 0%, rgba(182, 206, 59, 0.015) 100%),\n    var(--wz-card);\n}\n\n.agent-projects-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* Input bar ------------------------------------------------------------- */\n\n.agent-chat-input-bar {\n  background: linear-gradient(180deg, rgba(246, 247, 241, 0) 0%, var(--wz-bg) 40%);\n  padding: 10px 24px 30px;\n}\n\n.agent-chat-input-inner {\n  width: 60%;\n  min-width: 360px;\n  max-width: 900px;\n  margin: 0 auto;\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n  background: var(--wz-card);\n  border: 1px solid var(--wz-line-2);\n  border-radius: 22px;\n  padding: 10px 10px 10px 20px;\n  box-shadow: var(--wz-shadow-md);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.agent-chat-input-inner:focus-within {\n  border-color: var(--wz-green-strong);\n  box-shadow: 0 0 0 3px var(--wz-green-glow), var(--wz-shadow-md);\n}\n\n.agent-chat-input-inner .ant-input {\n  padding-left: 0;\n  font-size: 14.5px;\n}\n\n.agent-chat-input-inner .ant-btn {\n  flex-shrink: 0;\n  margin-bottom: 2px;\n  width: 38px;\n  height: 38px;\n  min-width: 38px;\n}\n\n/* Three blinking dots: shown while a turn is still running and blocks have\n   already been rendered, so the user can tell the agent is still working\n   during the quiet stretches between tool calls. */\n.agent-typing-dots {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 0;\n}\n\n.agent-typing-dots i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--wz-text-3);\n  opacity: 0.25;\n  animation: agent-typing-blink 1.4s infinite ease-in-out both;\n}\n\n.agent-typing-dots i:nth-child(2) { animation-delay: 0.2s; }\n.agent-typing-dots i:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes agent-typing-blink {\n  0%, 80%, 100% { opacity: 0.25; }\n  40%           { opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .agent-typing-dots i { animation: none; opacity: 0.6; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
